export default {
  methods: {
    changeInputField(event) {
      let charCode = event.which;
      // Check if a character is deleted and then moves to the previous page
      if ((charCode == 8 || charCode == 46) && event.target.value.length < 1) {
        const previousSibling = event.target.previousElementSibling;
        if (previousSibling === null) return;
        event.target.previousElementSibling.focus();
      } else if (
        // does character checks to prevent empty fields and moves to the next input field
        event.target.value
      ) {
        const next = event.target.nextElementSibling;
        if (next === null) return;
        event.target.nextElementSibling.focus();
      } else {
        event.preventDefault();
      }
      return;
    },
  },
};
